export const isHourDimension = (dimension) => {
  return ['Hour', 'RootHour'].includes(dimension);
};

export const isRootHourDimension = (dimension) => dimension === 'RootHour';
